<router-outlet></router-outlet>
<app-messenger></app-messenger>
<app-version-popover></app-version-popover>
